
import commonApi from "@/apis/common.api";
import { $_DKD } from "@/confs/common.const.js";

export default {
    state: {
        selectedRealtimeTab: 'Safety',
        selectedRealtimeSubTab: '',
        isLivetabPlaying: false,
    },
    getters: {
        getSelectedRealtimeTab(state) {
            return state.selectedRealtimeTab;
        },
        getSelectedRealtimeSubTab(state) {
            return state.selectedRealtimeSubTab;
        },
        getIsLivetabPlaying(state) {
            return state.isLivetabPlaying;
        },
    },
    mutations: {
        SELECTED_REALTIME_TAB(state, selectedRealtimeTab) {
            state.selectedRealtimeTab = selectedRealtimeTab;
        },
        SELECTED_REALTIME_SUB_TAB(state, selectedRealtimeSubTab) {
            state.selectedRealtimeSubTab = selectedRealtimeSubTab;
        },
        IS_LIVETAB_PLAYING(state, isLivetabPlaying) {
            state.isLivetabPlaying = isLivetabPlaying;
        },
    },
    actions : {
        SET_SELECTED_REALTIME_TAB({commit}, selectedRealtimeTab) {
            commit("SELECTED_REALTIME_TAB", selectedRealtimeTab);
        },
        SET_SELECTED_REALTIME_SUB_TAB({commit}, selectedRealtimeSubTab) {
            commit("SELECTED_REALTIME_SUB_TAB", selectedRealtimeSubTab);
        },
        SET_IS_LIVETAB_PLAYING({commit}, isLivetabPlaying) {
            commit("IS_LIVETAB_PLAYING", isLivetabPlaying);
        },
    }
};
